/* eslint-disable */
import statesDataRaw from './../components/Dashboard/Views/Customers/states'
import unitMapping from '../mixins/unitEfactura.json'
import moment from 'moment'
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
import { initAuditClient, trackAdminEvent, tableEntityKind } from '../services/audit'

window.appInstanceCache = {};
window.cache_date = null;
window.intervalForDatabaseCache = null;
const CACHE_TIME_LIMIT = 60000 * 720; // 1 minute * n
const MAX_REQUESTS_COUNT = 5
const INTERVAL_MS = 10
let PENDING_REQUESTS = 0

export default {
  props: {
    isLoading: true
  },
  data () {
    return {
      apiResponse: [],
      unitMapping: unitMapping,
      statesData: statesDataRaw
      // apiRequestHeader: {
      //   'Access-Control-Allow-Origin': '*'
      // }
    }
  },
  methods: {
    apiRequestPromise (url, method, data) {
      return new Promise((resolve, reject) => {
        this.apiRequest(url, method, data, (response) => {
          resolve(response)
          // if (response.status) {
          //   resolve(response)
          // } else {
          //   reject(response)
          // }
        })
      })
    },
    isOwner() {
      if (this.$session.get('userDataRole') === 'OWNER') {
        return true;
      }
      return false;
    },
    userHasRight (right) {
      if (right == '') {
        return true;
      }
      let userData = JSON.parse(this.$session.get('userData'))
      if(userData.role == 'OWNER') {
        return true;
      }
      if(userData.role == 'LOCATION_ADMIN' || userData.role == 'LOCATION_STORE_ADMIN' || userData.role == 'USER_CUSTOM') {
        if (right == 'GESTIUNE') { // daca are cel putin una bifata!
          const hasAtLeastOnePermission = Object.values(userData.permissions_map || {}).some(val => val === true);
          return hasAtLeastOnePermission;
        }
        if (userData.permissions_map) {
          return userData.permissions_map[right] === true
        }
      }
      return false;
    },
    canAccessPriceLists () {
      if (this.$session.get('userDataRole') !== 'USER_CUSTOM') {
        return true
      }
      return this.userHasRight('general_can_access_catalog') &&
        this.userHasRight('general_can_access_price_lists')
    },
    guardPriceListsAccess () {
      if (this.canAccessPriceLists()) {
        return true
      }
      this.$router.replace({ path: '/catalog', query: { tabIndex: 0 } })
      return false
    },
    getUnitText (unitCode) {
      if (this.unitMapping && this.unitMapping[unitCode] && this.unitMapping[unitCode].text) {
        const fullText = this.unitMapping[unitCode].text;

        var parts = fullText.split(" - ");
        if (parts.length > 1) {
          return parts.slice(1).join(" - ").trim();
        } else {
          return fullText;
        }
      }

      return unitCode;
    },
    getUnitCodeFromText (unitText) {
      if (!this.unitMapping) return unitText;

      // iterăm prin toate codurile
      for (const code in this.unitMapping) {
        const mapping = this.unitMapping[code];
        if (mapping && mapping.text && mapping.value) {
          // extragem partea vizibilă după " - "
          const parts = mapping.text.split(" - ");
          const displayText = parts.length > 1 ? parts.slice(1).join(" - ").trim() : mapping.text;

          // comparăm cu unitText: fie codul vizibil (BUC), fie numele
          if (displayText.toLowerCase() === unitText.toLowerCase() || code.toLowerCase() === unitText.toLowerCase()) {
            return mapping.value; // returnează codul SPV, ex: H87
          }
        }
      }

      console.log('unitText', unitText)

      return unitText; // dacă nu găsește, returnează ce ai dat
    },
    getOrderFormFlags () {
      return ['phone', 'email', 'inlocation', 'glovo', 'tazz'];
    },
    getAppIsLoading () {
      return this.isLoading
    },
    setAppIsLoading (newVal) {
      this.isLoading = newVal
    },
    localRequest (serverIpPort, url, method = 'GET', data = [], callback) {
      var apiRequestHeader = {
        'Access-Control-Allow-Origin': '*',
      }

      let target = null;
      if (!serverIpPort) {
        serverIpPort = 'http://localhost:65400'
      } else {
        target = serverIpPort;
        // data = { ...data, target }; nu este ok....data poate fi string...
        serverIpPort = 'http://localhost:3210'
      }

      const instance = this.axios.create({
        baseURL: serverIpPort,
        timeout: options.timeout || 90000,
        headers: apiRequestHeader
      })


      if (serverIpPort === 'http://localhost:3210' && target) {
        const separator = url.includes('?') ? '&' : '?';
        url = `${url}${separator}target=${encodeURIComponent(target)}`;
      }

      switch (method) {
        case 'GET':
          instance.get(url, {params: data})
            .then(
              (response) => {
                callback(response)
              }
              ,
              (error) => {
                let response = {'status': false, 'error': error}
                callback(response)
              }
            )
            .catch((error) => {
              let response = {'status': false, 'error': error}
              callback(response)
            })
          break
        case 'POST':
          instance.post(url, data)
            .then(
              (response) => {
                callback(response)
              }
            ).catch((error) => {
              let response = {'status': false, 'error': error}
              callback(response)
            })
          break
        case 'PUT':
          instance.put(url, data)
            .then(
              (response) => {
                callback(response)
              }
            )
          break
        case 'DELETE':
          instance.delete(url, {params: data})
          // instance.delete(url, data)
            .then(
              (response) => {
                callback(response)
              }
            )
          break
      }
    },
    isExpiredAuthMessage (message) {
      if (!message || typeof message !== 'string') {
        return false
      }
      const normalized = message.toLowerCase()
      return (
        normalized === 'token has expired' ||
        normalized === 'token not provided' ||
        normalized === 'token signature could not be verified.' ||
        normalized.includes('token has expired') ||
        normalized.includes('token not provided') ||
        normalized.includes('token signature could not be verified')
      )
    },
    isExpiredAuthPayload (payload) {
      if (!payload || typeof payload !== 'object') {
        return false
      }
      const candidates = [
        payload.error,
        payload.message,
        payload.errors && payload.errors.error,
        payload.errors && payload.errors.message,
        payload.data && payload.data.error,
        payload.data && payload.data.message
      ]
      return candidates.some((value) => this.isExpiredAuthMessage(value))
    },
    killExpiredSession (responseOrError) {
      // HTTP 200-style body: { status: false, errors: { error: 'Token has expired' } }
      if (responseOrError && responseOrError.data && this.isExpiredAuthPayload(responseOrError.data)) {
        this.forceLogout()
        return true
      }

      // Axios error / HTTP 401
      const axiosResponse = responseOrError && responseOrError.response
      if (axiosResponse) {
        const status = axiosResponse.status
        const body = axiosResponse.data
        if (status === 401 || this.isExpiredAuthPayload(body)) {
          this.forceLogout()
          return true
        }
      }

      // Direct payload passed from callers
      if (this.isExpiredAuthPayload(responseOrError)) {
        this.forceLogout()
        return true
      }

      return false
    },
    apiRequest (url = '/hello', method = 'GET', data = [], callback, options = {}) {
      var authToken = ''
      if (data.token) {
        authToken = 'Bearer ' + data.token
      } else {
        authToken = ''
      }
      var apiRequestHeader = {
        'Access-Control-Allow-Origin': '*',
        'Authorization': authToken
      }

      const instance = this.axios.create({
        baseURL: process.env.API_BASE_URL,
        timeout: options.timeout || 90000,
        adapter: this.cacheAdapterEnhancer,
        headers: apiRequestHeader
      })

      instance.interceptors.request.use(function (config) {
        return new Promise((resolve, reject) => {
          let interval = setInterval(() => {
            if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
              PENDING_REQUESTS++
              clearInterval(interval)
              resolve(config)
            }
          }, INTERVAL_MS)
        })
      })

      instance.interceptors.response.use(function (response) {
        PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
        return Promise.resolve(response)
      }, function (error) {
        PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
        return Promise.reject(error)
      })

      const cacheKey = JSON.stringify({ url, method, data });
      if (window.appInstanceCache[cacheKey] && (Date.now() - window.appInstanceCache[cacheKey].timestamp) < CACHE_TIME_LIMIT) {
        // If response is cached and not expired, return it
        callback(JSON.parse(JSON.stringify(window.appInstanceCache[cacheKey].response.data)));
        return;
      }

      const handleSuccess = (response) => {
        if (this.killExpiredSession(response)) {
          return
        }
        if (method === 'GET' && data.with_cache) {
          window.appInstanceCache[cacheKey] = {
            response: JSON.parse(JSON.stringify(response)),
            timestamp: Date.now()
          }
        }
        callback(response.data)
      }

      const handleError = (error) => {
        if (this.killExpiredSession(error)) {
          return
        }
        callback({ status: false, error: error })
      }

      switch (method) {
        case 'GET':
          instance.get(url, {params: data})
            .then(handleSuccess, handleError)
            .catch(handleError)
          break
        case 'POST':
          instance.post(url, data)
            .then(handleSuccess)
            .catch(handleError)
          break
        case 'PUT':
          instance.put(url, data)
            .then(handleSuccess)
            .catch(handleError)
          break
        case 'DELETE':
          instance.delete(url, {params: data})
          // instance.delete(url, data)
            .then(handleSuccess)
            .catch(handleError)
          break
      }
    },
    openDatabaseAndReadOrCreate(dbName, version, storeName, $insert1Read0) {
      let self = this
      // Open a connection to the database
      let request = indexedDB.open(dbName, version);

      // Handle database setup or upgrade
      request.onupgradeneeded = (event) => {
        let db = event.target.result;
        // Create an object store if it doesn't exist
        console.log(db.objectStoreNames);
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { keyPath: 'key' });
        }
      };

      // Handle success opening database
      request.onsuccess = (event) => {
        let db = event.target.result;
        if ($insert1Read0) {
          self.insertDefaultData(db, storeName);
        } else {
          // Start a transaction to read data
          let transaction = db.transaction([storeName], 'readonly');
          let objectStore = transaction.objectStore(storeName);

          // Get all records from the object store
          let getAllRequest = objectStore.getAll();

          getAllRequest.onsuccess = (event) => {
            let records = event.target.result;
            let reconstructedObject = {};
            records.forEach(record => {
              reconstructedObject[record.key] = record.value;
            });
            window.appInstanceCache = reconstructedObject;
            console.log('getFromDb')
          };

          getAllRequest.onerror = (event) => {
            // console.error('Error reading records:', event.target.error);
          };

          transaction.oncomplete = () => {
            db.close();
          };
        }
      };

      request.onerror = (event) => {
        console.error('Database error:', event.target.error);
      };
    },
    insertDefaultData(db, storeName) {
      let transaction = db.transaction([storeName], 'readwrite');
      let objectStore = transaction.objectStore(storeName);

      let defaultData = Object.entries(window.appInstanceCache);

      defaultData.forEach(([key, value]) => {

        let item = {
          key: key,
          value: value
        };

        let putRequest = objectStore.put(item);

        putRequest.onsuccess = (event) => {
          // console.log('Default data inserted or updated:', item);
        };

        putRequest.onerror = (event) => {
          // console.error('Error inserting or updating default data:', event.target.error);
        };
      });

      transaction.oncomplete = () => {
        db.close();
        console.log('savedInDb')
      };
    },
    clearAppInstanceCache () {
      window.appInstanceCache = {}
      const companyID = this.$session.get('selectedCompany')
      if (!companyID) {
        return
      }
      const databaseName = 'tapTasty_' + companyID
      indexedDB.deleteDatabase(databaseName)
      window.cache_date = new Date()
      localStorage['tapTastyMenu_cache_date_' + companyID] = window.cache_date.toISOString()
    },
    ensureCompanyLocationFlags (callback) {
      const sessionData = this.$session.get('selectedCompanyData') || {}
      if (sessionData.has_charisma_location !== undefined && sessionData.has_nexus_location !== undefined) {
        if (callback) {
          callback(sessionData)
        }
        return
      }

      const companyId = this.$session.get('selectedCompany')
      if (!companyId) {
        if (callback) {
          callback(sessionData)
        }
        return
      }

      this.apiRequest('/listdefaults', 'GET', {
        token: this.$session.get('token'),
        company_id: companyId
      }, (response) => {
        if (response.status === true && response.data && response.data[0]) {
          sessionData.has_charisma_location = !!response.data[0].has_charisma_location
          sessionData.has_nexus_location = !!response.data[0].has_nexus_location
          this.$session.set('selectedCompanyData', sessionData)
        }
        if (callback) {
          callback(sessionData)
        }
      })
    },
    /**
     * Keep only the company/location fields the app reads from selectedCompanyData.
     * Also preserve lazily-cached session fields (payment_methods, etc.).
     */
    buildCompanySessionData (companyData, existingData) {
      if (!companyData) {
        return companyData
      }

      const existing = existingData || this.$session.get('selectedCompanyData') || {}
      const companyFields = [
        'id',
        'name',
        'role',
        'currency_iso',
        'currency_display_format',
        'time_format',
        'date_format',
        'timezone',
        'delivery_options_labels',
        'homepage',
        'use_gestiune',
        'use_dispatch',
        'default_location_for_admin_order',
        'is_allowed_sound_at_new',
        'is_allowed_sound_at_processing',
        'is_allowed_on_hold',
        'is_allowed_postponed',
        'automated_processed_status',
        'edit_price',
        'print_fiscal_from_dashboard',
        'api_client_key',
        'use_pos_id_per_product_option',
        'use_quantity_per_product_option',
        'sort_product_method',
        'price_details',
        'loyalty_in_use',
        'use_marketing_gift_card',
        'loyalty_store_in_use',
        'loyalty_value_one_point',
        'loyalty_value_one_point_amount',
        'loyalty_value_one_currency',
        'fidelities_labels_primary_option'
      ]
      const locationFields = [
        'id',
        'true_id',
        'name',
        'token',
        'use_printer',
        'drcarmen_active',
        'auto_print',
        'google_maps_api_key'
      ]
      const preserveFields = [
        'payment_methods',
        'administrations',
        'compact_pos_list',
        'locations_list',
        'has_charisma_location',
        'has_nexus_location',
        'role'
      ]

      const slim = {}
      for (let i = 0; i < companyFields.length; i++) {
        const key = companyFields[i]
        if (existing[key] !== undefined) {
          slim[key] = existing[key]
        }
      }
      for (let i = 0; i < companyFields.length; i++) {
        const key = companyFields[i]
        if (companyData[key] !== undefined) {
          slim[key] = companyData[key]
        }
      }

      if (Array.isArray(companyData.locations_details)) {
        slim.locations_details = companyData.locations_details.map((loc) => {
          const out = {}
          for (let i = 0; i < locationFields.length; i++) {
            const key = locationFields[i]
            if (loc[key] !== undefined) {
              out[key] = loc[key]
            }
          }
          out.ordering_management = Array.isArray(loc.ordering_management)
            ? loc.ordering_management.map((om) => ({
              id: om.id,
              type: om.type,
              default_waiting_time: om.default_waiting_time
            }))
            : []
          if (loc.table_management) {
            out.table_management = {
              qr_code: loc.table_management.qr_code,
              qr_link: loc.table_management.qr_link,
              type: loc.table_management.type,
              number: loc.table_management.number
            }
          }
          return out
        })
      } else if (Array.isArray(existing.locations_details)) {
        slim.locations_details = existing.locations_details
      }

      for (let i = 0; i < preserveFields.length; i++) {
        const key = preserveFields[i]
        if (slim[key] === undefined && existing[key] !== undefined) {
          slim[key] = existing[key]
        }
      }

      return slim
    },
    syncCompanySessionAndCache (companyData, callback) {
      const applyCompanyData = (data) => {
        if (data) {
          this.$session.set('selectedCompanyData', this.buildCompanySessionData(data))
        }
        this.clearAppInstanceCache()
        if (callback) {
          callback(data)
        }
      }

      if (companyData) {
        applyCompanyData(companyData)
        return
      }

      const companyID = this.$session.get('selectedCompany')
      if (!companyID) {
        this.clearAppInstanceCache()
        if (callback) {
          callback()
        }
        return
      }

      this.apiRequest('/settings/general/' + companyID, 'GET', {
        token: this.$session.get('token')
      }, (response) => {
        if (response.status === true && response.data && response.data[0]) {
          applyCompanyData(response.data[0])
        } else {
          this.clearAppInstanceCache()
          if (callback) {
            callback()
          }
        }
      })
    },
    logout () {
      swal({
        text: this.$t('general.doYouWantToLogout'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then((result) => {
        if (result) {
          this.forceLogout()
        }
      }).catch(() => {})
    },
    forceLogout () {
      this.$session.set('newOrders', 0)
      this.$session.set('processingOrders', 0)
      this.$session.destroy()
      this.$router.push('/login')
      this.$i18n.locale = 'en'
    },
    getCompanyDetail (key) {
      // var companyID = this.$session.get('selectedCompany')
      // var userData = JSON.parse(this.$session.get('userData'))
      // var defaultData = this.$session.get('defaultData')

      // var companyDetails = this.getObjectByElemKeyValue('id', companyID, userData.companies)
      // companyDetails = userData.companies[companyDetails]
      var companyDetails = this.$session.get('selectedCompanyData')

      switch (key) {
        case 'currency':
          return companyDetails.currency_iso
        case 'currency_display_format':
          return companyDetails.currency_display_format
        case 'time_format':
        case 'date_format':
        case 'delivery_options_labels':
        case 'locations_details':
          return companyDetails[key]
      }

      return ''
    },
    getUserAddress (addressDetails) {
      let address = ''
      if (addressDetails.street) {
        address = addressDetails.street
      }

      if (addressDetails.number) {
        if (address) {
          address += ' ' + addressDetails.number
        } else {
          address += addressDetails.number
        }
      }

      if (addressDetails.apartment) {
        if (address) {
          address += ', ' + addressDetails.apartment
        } else {
          address += addressDetails.apartment
        }
      }

      if (addressDetails.city) {
        if (address) {
          address += ', ' + addressDetails.city
        } else {
          address += addressDetails.city
        }
      }

      if (addressDetails.state) {
        if (address) {
          address += ', ' + addressDetails.state
        } else {
          address += addressDetails.state
        }
      }

      return address
    },
    getUserLabel (labels, amount, orders, labelingPrimaryOption) {
      if (!amount) {
        amount = 0
      }
      let userLabel = ''
      let userColor = ''
      let maxAmount = 0
      let maxOrders = 0
      labels.forEach(function (label) {
        if (label.order_value <= amount && label.order_numbers <= orders) {
          if (labelingPrimaryOption === 'ordersValue') {
            if (maxAmount < label.order_value) {
              maxAmount = label.order_value
              maxOrders = label.order_numbers
              userColor = label.color
              userLabel = label.name
            } else if (maxAmount === label.order_value) {
              if (maxOrders < label.order_numbers) {
                maxAmount = label.order_value
                maxOrders = label.order_numbers
                userColor = label.color
                userLabel = label.name
              }
            }
          } else {
            if (maxOrders < label.order_numbers) {
              maxAmount = label.order_value
              maxOrders = label.order_numbers
              userColor = label.color
              userLabel = label.name
            } else if (maxOrders === label.order_numbers) {
              if (maxAmount < label.order_value) {
                maxAmount = label.order_value
                maxOrders = label.order_numbers
                userColor = label.color
                userLabel = label.name
              }
            }
          }
        }
      })
      if (userColor) {
        return '<span style="color: ' + userColor + '">' + userLabel + '</span>'
      } else {
        return userLabel
      }
    },
    getLocalDateTimeString () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day}T${hours}:${minutes}`
    },
    formatToCompanyTimezone (utcString, timezone) {
      const date = new Date(utcString + 'Z')
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      })

      const parts = formatter.formatToParts(date)

      return `${parts.find(p => p.type === 'year').value}-${
        parts.find(p => p.type === 'month').value}-${
        parts.find(p => p.type === 'day').value} ${
        parts.find(p => p.type === 'hour').value}:${
        parts.find(p => p.type === 'minute').value}:${
        parts.find(p => p.type === 'second').value}`
    },
    getMesurementsUnits () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      return new Promise((resolve, reject) => {
        this.apiRequest('/measurements-units', 'GET', data, (response) => {
          if (response.status === true) {
            resolve(response.data)
          } else {
            resolve([]) // sau reject dacă vrei
          }
        })
      })
    },
    formatMoneyAmount (amount, currency = '', removezero = false) {
      if (currency === '') {
        currency = this.getCompanyDetail('currency')
      }
      var position = this.getCurrencyPosition(currency)
      currency = this.getCurrencySymbol(currency)
      var space = ' '

      if (amount === null) {
        amount = 0
      }

      if (removezero && amount % 1 === 0) {
        amount = Math.abs(amount)
      }
      // console.log(amount)
      // console.log(Math.abs(amount))

      if (amount !== 0) {
        amount = parseFloat(amount)
        amount = amount.toFixed(2)
      }
      if (position === 'left') {
        return currency + amount
      } else {
        return amount + space + currency
      }
    },
    getTimeFormat () {
      let format = this.getCompanyDetail('time_format')
      let formatTime = format !== '' ? format : 'H:mm'
      return formatTime
    },
    formatTime (value) {
      if (value) {
        let format = this.getCompanyDetail('time_format')
        let formatTime = format !== '' ? format : 'H:mm'
        return moment(String(value)).format(formatTime)
      }
    },
    formatDate (value) {
      if (value) {
        let format = this.getCompanyDetail('date_format')
        let formatDate = format !== '' ? format : 'DD/MM/YYYY'
        let m = moment(String(this.normalizeDateValue(value)))
        if (!m.isValid()) {
          return ''
        }
        return m.format(formatDate)
      }
    },
    formatDateTime (value) {
      if (value) {
        let format1 = this.getCompanyDetail('time_format')
        let format2 = this.getCompanyDetail('date_format')
        let format = format1 + ' ' + format2
        return moment(String(this.normalizeDateValue(value))).format(format)
      }
    },
    normalizeDateValue (value) {
      if (value && typeof value === 'object' && !Array.isArray(value) && value.date) {
        return value.date
      }
      return value
    },
    limitChars (text, maxLength) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...'
      } else {
        return text
      }
    },
    getObjectByElemKeyValue (key, value, objects) {
      for (var index in objects) {
        if (objects[index][key] === value) {
          return index
        }
      }
      return false
    },
    getObjectByElemKeyValueBool (key, value, objects) {
      for (var index in objects) {
        if (objects[index][key] === value) {
          return true
        }
      }
      return false
    },
    isInObject (value, object) {
      for (var index in object) {
        if (parseInt(object[index]) === parseInt(value)) {
          return true
        }
      }
      return false
    },
    globalGoToRecord (row, event, column = null, baseUrl = '') {
      const blockedColumns = ['actions', 'active']

      if (!column || !blockedColumns.includes(column.property)) {
        this.$router.push(baseUrl + row.id)
      }
    },
    defaultActionDef () {
      return {
        show: false,
        colProps: {
          span: 0
        },
        def: []
      }
    },
    defaultSearchDef () {
      return {
        colProps: {
          span: 14
        }
      }
    },
    orderStatusClass (type) {
      switch (type) {
        case 'DELIVERED': return 'success'
        case 'CANCELED': return 'danger'
        case 'NOT_DELIVERED': return 'danger'
        case 'NEW': return 'info'
        case 'ON_HOLD': return 'hold'
        case 'POSTPONED': return 'postponed'
        case 'PROCESSING': return 'warning'
        case 'AWAITING_TRANSPORT': return 'yellow'
        case 'PICKED_UP_BY_DELIVERY': return 'grey'
        case 'TRANSPORT': return 'blue'
        default: return 'primary'
      }
    },
    orderStatusButtonColor (type) {
      switch (type) {
        case 'DELIVERED': return '#7AC29A'
        case 'CANCELED': return '#EB5E28'
        case 'NOT_DELIVERED': return '#EB5E28'
        case 'OPEN_DRAFT': return '#5e35b1'
        case 'NEW': return '#68B3C8'
        case 'ON_HOLD': return '#8d5e27'
        case 'POSTPONED': return '#8d5e27'
        case 'PROCESSING': return '#F3BB45'
        case 'AWAITING_TRANSPORT': return '#ffc107'
        case 'PICKED_UP_BY_DELIVERY': return '#66615B'
        case 'TRANSPORT': return '#66615B'
        default: return '#5e35b1'
      }
    },
    orderStatusAllowed (currentSts, otherSts) {
      switch (currentSts) {
        case 'NEW':
          if (otherSts === 'NEW' || otherSts === 'PROCESSING' || otherSts === 'CANCELED' || otherSts === 'ON_HOLD' || otherSts === 'POSTPONED') {
            return true
          } else {
            return false
          }
        case 'CANCELED': return false
        default: return true
      }
    },
    feedbackTypeClass (type) {
      switch (type) {
        case 'feedback': return 'success'
        case 'issue': return 'danger'
        case 'suggestion': return 'warning'
        default: return 'info'
      }
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    fetchVats(locationId) {
      const dataToSend = {
        company_id: this.companyID,
        token: this.$session.get('token'),
        location_id: locationId
      }

      return new Promise((resolve, reject) => {
        this.apiRequest('/gestiune/locations-vats', 'GET', dataToSend, (response) => {
          if (!response || response.status !== true || !response.data || !response.data.tax) {
            swal({
              title: 'Eroare!',
              text: response.message || 'Eroare la preluarea cotelor TVA.',
              icon: 'error',
              timer: 3000,
              showConfirmButton: false
            })
            resolve([])
            return
          }

          this.vats = response.data.tax
          resolve(response.data.tax)
        })
      })
    },
    getCoutryStates (country) {
      // statesList
      var countryArr = this.statesData.countries
      var stateArr = this.statesData.states
      var index = 0
      var i = 0

      for (let name of countryArr) {
        i++
        if (name === country) {
          index = i
        }
      }

      var states = stateArr[index].split('|')

      return states
    },
    getDaysLeft (date) {
      var date1 = new Date(date)
      var date2 = new Date()
      var timeDiff = date1.getTime() - date2.getTime()
      var diffDays = timeDiff / (1000 * 3600 * 24)

      return diffDays > 0 ? Math.ceil(diffDays) : 0
    },
    isJSONString (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    copyObject (o) {
      var output, v, key
      output = {} // Array.isArray(o) ? [] : {}
      for (key in o) {
        v = o[key]
        output[key] = (typeof v === 'object') ? this.copyObject(v) : v
      }
      return output
    },
    copyCompanyOptionValueWithoutIds (o) {
      var output, v, key
      output = [] // Array.isArray(o) ? [] : {}
      for (key in o) {
        v = o[key]
        output[key] = (typeof v === 'object') ? this.copyObject(v) : v

        delete output[key]['id']
        delete output[key]['option_id']
        if (typeof output[key]['pos_id'] === 'object') {
          delete output[key]['pos_id']
        }

        if (typeof output[key]['vat_id'] === 'object') {
          delete output[key]['vat_id']
        }
      }
      return output
    },
    copyVar (o) {
      var output, v, key
      output = Array.isArray(o) ? [] : {}
      for (key in o) {
        v = o[key]
        output[key] = (typeof v === 'object') ? this.copyVar(v) : v
      }
      return output
    },
    arrDiff (a1, a2) {
      let a = []
      let diff = []
      for (let i = 0; i < a1.length; i++) {
        a[a1[i]] = true
      }

      for (let i = 0; i < a2.length; i++) {
        if (a[a2[i]]) {
          delete a[a2[i]]
        } else {
          a[a2[i]] = true
        }
      }

      for (let k in a) {
        diff.push(k)
      }

      return diff
    },
    removeErrorByName (name, errors) {
      let returnErr = []
      if (errors.length) {
        for (let idx in errors) {
          if (errors[idx]['field'] !== name) {
            returnErr.push(errors[idx])
          }
        }
      }
      return returnErr
    },
    getAge (birthdate) {
      var timestamp = Math.floor(new Date().getTime() / 1000)
      return Math.floor((timestamp - moment(birthdate).format('X')) / 31556926)
    },
    getCurrencyPosition (iso) {
      var currencies = this.$session.get('defaultData')['currencies']
      var currency = this.getObjectByElemKeyValue('iso', iso, currencies)

      return currencies[currency]['symbol_position'] ? currencies[currency]['symbol_position'] : 'right'
    },
    getCurrencySymbol (iso) {
      var currencies = this.$session.get('defaultData')['currencies']
      var currency = this.getObjectByElemKeyValue('iso', iso, currencies)

      if (!currency) {
        return iso
      }

      return currencies[currency]['symbol'] ? this.decodeHtml(currencies[currency]['symbol']) : iso
    },
    decodeHtml (html) {
      var txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    },
    getGestiuneApiBaseUrl () {
      return `${String(process.env.API_BASE_URL_GESTIUNE || '').replace(/\/$/, '')}:4443`
    },
    normalizeAnafCui (cui) {
      return String(cui || '').replace(/\D/g, '')
    },
    parseAnafCuiResponse (payload) {
      const root = payload && payload.date_generale
        ? payload
        : (payload && payload.data && payload.data.date_generale ? payload.data : payload) || {}

      const general = root.date_generale || root
      const hq = root.adresa_sediu_social || {}
      const fiscal = root.adresa_domiciliu_fiscal || {}
      const address = hq.sdenumire_Strada || hq.snumar_Strada ? hq : fiscal

      const street = address.sdenumire_Strada || address.ddenumire_Strada || ''
      const streetNumber = address.snumar_Strada || address.dnumar_Strada || ''
      const city = address.sdenumire_Localitate || address.ddenumire_Localitate || ''
      const countyCode = address.scod_JudetAuto || address.dcod_JudetAuto || ''
      const countyName = address.sdenumire_Judet || address.ddenumire_Judet || ''
      const postalCode = address.scod_Postal || address.dcod_Postal || general.codPostal || ''

      const addressParts = [street, streetNumber, city, countyName].filter(Boolean)
      const fullAddress = general.adresa || addressParts.join(', ')

      return {
        cui: String(general.cui || ''),
        name: general.denumire || '',
        phone: general.telefon || '',
        fax: general.fax || '',
        registrationNumber: general.nrRegCom || '',
        iban: general.iban || '',
        address: fullAddress,
        street,
        streetNumber,
        city,
        countyCode,
        countyName,
        postalCode,
        countryCode: 'RO',
        isVatPayer: !!(root.inregistrare_scop_Tva && root.inregistrare_scop_Tva.scpTVA)
      }
    },
    async fetchAnafCompanyByCui (cui) {
      const normalizedCui = this.normalizeAnafCui(cui)

      if (!normalizedCui) {
        throw new Error('CUI lipsă sau invalid.')
      }

      const url = `${this.getGestiuneApiBaseUrl()}/anaf/verifica-cui?cui=${encodeURIComponent(normalizedCui)}`
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })

      let payload = null
      try {
        payload = await response.json()
      } catch (e) {
        payload = null
      }

      if (!response.ok) {
        const message = (payload && (payload.error || payload.message || payload.eroare)) ||
          (response.status === 404 ? 'CUI negăsit la ANAF.' : 'Verificarea CUI a eșuat.')
        throw new Error(message)
      }

      return this.parseAnafCuiResponse(payload)
    },
    applyAnafCompanyToFields (company, target = 'invoiceClient') {
      if (!company) return

      if (target === 'invoiceClient') {
        if (company.name) this.clientName = company.name
        if (company.phone) this.clientPhone = company.phone
        this.clientCountryCode = company.countryCode || this.clientCountryCode || 'RO'
        if (company.countyCode) this.clientCountyCode = company.countyCode
        if (company.city) this.clientCity = company.city
        if (company.street) this.clientStreet = company.street
        if (company.streetNumber) this.clientStreetNumber = company.streetNumber
        if (company.postalCode) this.clientPostalCode = company.postalCode
        return
      }

      if (target === 'simpleClient') {
        if (company.name) this.clientName = company.name
        if (company.phone) this.clientPhone = company.phone
        if (company.address) this.clientAddress = company.address
        return
      }

      if (target === 'nomenclatorClient') {
        this.client = {
          ...this.client,
          companyName: company.name || this.client.companyName,
          CUI: company.cui || this.client.CUI,
          registrationNumber: company.registrationNumber || this.client.registrationNumber,
          address: company.address || this.client.address,
          city: company.city || this.client.city,
          countries: company.countryCode || this.client.countries || 'RO',
          IBAN: company.iban || this.client.IBAN
        }
        return
      }

      if (target === 'nomenclatorSupplier') {
        this.supplier = {
          ...this.supplier,
          companyName: company.name || this.supplier.companyName,
          CUI: company.cui || this.supplier.CUI,
          registrationNumber: company.registrationNumber || this.supplier.registrationNumber,
          address: company.address || this.supplier.address,
          IBAN: company.iban || this.supplier.IBAN
        }
      }
    },
    orderTimeDelivery () {
      const minutes = [5, 15, 30, 45, 60]
      return minutes
    },
    weekDays () {
      return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    },
    getCompany (inactive = 1) {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        inactive
      }

      const request = this.apiRequest('/company-data', 'GET', data)

      console.log(request) // <-- aici vei vedea Promise, nu response

      return request
    },
    initAuditClient (options) {
      return initAuditClient(this, options)
    },
    trackAdminEvent (eventName, entityType, entityId, payload) {
      trackAdminEvent(this, eventName, entityType, entityId, payload || {})
    },
    tableEntityKind (modelType) {
      return tableEntityKind(this, modelType)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Inmobito.js